import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black py-12 border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6">
        {/* Main footer content */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 mb-8">
          {/* Logo */}
          <Link to="/" className="font-italiana text-xl tracking-[0.4em] text-white/50 hover:text-white transition-colors">
            <span className="text-[#D4A574]">V</span>IVANT
          </Link>
          
          {/* Contact */}
          <div className="text-center md:text-right">
            <p className="text-white/40 text-xs tracking-wider mb-1">CONTACT</p>
            <a 
              href="mailto:contact@vivant.co" 
              className="text-white/70 hover:text-[#D4A574] text-sm transition-colors"
            >
              contact@vivant.co
            </a>
          </div>
        </div>
        
        {/* Legal links */}
        <div className="border-t border-white/5 pt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-white/30 text-xs">
              © {new Date().getFullYear()} VIVANT. Tous droits réservés.
            </p>
            <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs">
              <Link 
                to="/legal/mentions-legales" 
                className="text-white/40 hover:text-white transition-colors"
                data-testid="footer-mentions-legales"
              >
                Mentions légales
              </Link>
              <Link 
                to="/legal/cgv" 
                className="text-white/40 hover:text-white transition-colors"
                data-testid="footer-cgv"
              >
                CGV
              </Link>
              <Link 
                to="/legal/confidentialite" 
                className="text-white/40 hover:text-white transition-colors"
                data-testid="footer-confidentialite"
              >
                Politique de confidentialité
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
